import { render, staticRenderFns } from "./productLineCapacityTable.vue?vue&type=template&id=5a36017c&scoped=true"
import script from "./productLineCapacityTable.vue?vue&type=script&lang=js"
export * from "./productLineCapacityTable.vue?vue&type=script&lang=js"
import style0 from "./productLineCapacityTable.vue?vue&type=style&index=0&id=5a36017c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36017c",
  null
  
)

export default component.exports